import Api from '@/axios'

export default {
    // 获取验证码
    captchaImage: Api.newGet(`captcha/randomCaptcha`),
    // 登陆
    login: Api.newPost(`user/login`),
    // 退出登陆
    loginout: Api.newGet(`user/logout`),
    // 获取用户信息
    getUserInfo: Api.newGet(`user/userInfo`),
    // 获取应用分组
    getClientGroup: Api.newGet(`client/group-list`),
    // 获取用户平台ITEM；
    getApplications: Api.newGet(`qauth/account/getApplications`),
    // 根据用户ID获取首页消息提醒
    getIndexInfo: Api.newPost(`sendLog/findIMPage`), // 缺少字段
    // 根据用户获取未读消息数量
    getCountReadStatus: Api.newPost(`sendLog/countReadStatus`),
    // 修改已读未读状态
    batchUpdateReadStatus: Api.newPost(`sendLog/batchUpdateReadStatus`),
    // 查询更多消息
    getMoreInfo: Api.newPost(`sendLog/findPage`), // 缺少字段
    // 查询更多待办事项各自数量
    getMissionNum: Api.newGet(`workbench/agencyTableStatistics`),
    // 查询待办事项来源 
    getSourceOptions: Api.newPost(`client/findList`),
    // 查询我发起的
    getMyInitiated: Api.newGet(`/workbench/myInitiated`),
    // 查询待我处理
    getToDoMission: Api.newGet(`/workbench/unfinishedTask`),
    // 查询待我处理
    getDoneMission: Api.newGet(`/workbench/historicalTask`),
    // 修改密码
    modifyPassword: Api.newPost(`/user/modifyPassword`),
    // 查询用户信息
    findUserInfoPageList: Api.newPost(`/user/findPage`),
    // 编辑用户信息
    editorUserCount: Api.newPost(`/user/update`),
    // 获取帮助中心列表数据
    helpList: Api.newPost(`/help-document/findPage`),
    // 获取首页通知公告
    getNoticeInfo: Api.newPost(`notice/findPage`), 
    // 获取全局配置数据
    getGlobalConfig: Api.newPost(`/layout/config/list`),
    // 获取基础配置数据
    getBaseConfig: Api.newPost(`/config/list`),
    // 获取预览文件地址
    getPreviewFile: Api.newGet(`/common/url/get`),
    // 修改用户头像
    updateUserAvatar: Api.newPut(`/user/avatar`),
    // 刷新token
    refreshTokenApi: Api.newPost(`/user/refreshToken`),
    // 查询用户常用应用
    getCommonApp: Api.newGet(`/client/common/list`),
    // 保存用户常用应用
    saveCommonApp: Api.newPost(`/client/common/save`),
}
